import Component from '../core/Component'
import $ from 'jquery'
import { throttle } from 'underscore'

export default class Menu extends Component {

    constructor($element) {
        super($element);

        this.value = this.$element.data('value')
        this.pre = this.$element.data('pre')
        this.after = this.$element.data('after')
        this.active = true

        this.$content = this.$element.find('[data-animate-number]')
    }

    prepare() {
        var pre = this.$element.data('pre')
        var after = this.$element.data('after')

        var text = ""
        if (pre == null && after == null) {
            text = "" + 0
        } else if (pre != null && after == null) {
            text = "" + pre + 0
        } else if (pre == null && after != null) {
            text = "" + 0 + after
        } else {
            text = "" + pre + 0 + after
        }

        this.$content.html(text)

        this.$element.on('hasDisplayed', () => {
            this.animateValue(0, this.value, 1200)
        })
    }

    animateValue(start, end, duration) {
        var pre = this.$element.data('pre')
        var after = this.$element.data('after')

        var range = end - start
        var current = start
        var increment = end > start? 1 : -1
        var stepTime = Math.abs(Math.floor(duration / range))
        var timer = setInterval(() => {
            current += increment

            var text = ""
            if (pre == null && after == null) {
                text = "" + parseInt(current)
            } else if (pre != null && after == null) {
                text = "" + pre + parseInt(current)
            } else if (pre == null && after != null) {
                text = "" + parseInt(current) + after
            } else {
                text = "" + pre + parseInt(current) + after
            }

            this.$content.html(text)

            if (current == end) {
                clearInterval(timer)
            }
        }, stepTime)
    }
}


// WEBPACK FOOTER //
// ./components/AnimateNumber.js